export default "__VITE_ASSET__BPBw6m6O__"